const featureToggle = {
  CAMPAIGN_EDIT: true,
  CAMPAIGN_COPY: true,
  CUSTOM_PUBLISHERS: true,
  SHOWCASE_CREATIVE: true,
  INDIVIDUAL_PUBLISHER_SELECTION: false,
  MULTIPLE_CREATIVES: false,
  MANAGED_CAMPAIGNS: false,
  SHOW_SELF_SERVICE_DASHBOARD: false,
};

export default featureToggle;
